// extracted by mini-css-extract-plugin
export default {"pageWrap":"Ca-z","fullWidth":"Da-z","heading":"Ea-z","fullBleed":"Fa-z","hidden":"Ga-z"};